export default "__VITE_ASSET__Dg87e3pe__"